<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false" @close="resetForm">
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" ref="form" :rules="rules" :model="formData">
      <template  v-for="(item, index) in formItems">
        <el-form-item :label="$t(item.label)" :key="index" :prop="item.prop" v-if="item.type === 'image'">
          <pic-upload
              :limit="1"
              v-model="formData[item.prop]"
              :download-url="$api.file.downloadImg"
              :action="$api.file.upload" />
        </el-form-item>

        <el-form-item :label="$t(item.label)" :key="index" :prop="item.prop" v-else>
          <slot :name="item.prop" :row="formData">
            <el-input :placeholder="$t(item.label)" v-model="formData[item.prop]" :type="item.type" :rows="item.rows" />
          </slot>
        </el-form-item>
      </template>


    </el-form>
    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";
import PicUpload from "@/components/pic-upload/PicUpload";
import {getProtocol} from "@/utils/protocol";

export default {
  name: "HardwareForm",
  components: {PicUpload},
  props: {
    formItems: {
      type: Array,
      default() {
        return [
          {label: "无操作", prop: "test", type: "input",rows: 5}
        ]
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {}
    }
  },
  methods: {
    // 构建协议
    buildProtocol(e) {
      console.log('e', e);
      const test = "ee050200";
      const protocol = getProtocol(test, 1, 2);
      console.log("crc", protocol);
    },

    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit("confirm", this.formData);
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    },
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      },
      deep: true,
    },
    formItems: {
      handler(list) {
        list.forEach(item => {
          this.$set(this.formData, item.prop, "");
        })
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
